import React, { useState, useEffect } from "react"
import styles from "./Countdown.module.css"
import { useAppContext } from "../../stores/appStore"

export default function Countdown() {
  const [seconds, setSeconds] = useState(null)
  const [tick, setTick] = useState(0)
  const { showCountDown } = useAppContext()

  useEffect(() => {
    let interval

    if (showCountDown) {
      setSeconds(5)
      setTick(t => t + 1)

      interval = setInterval(() => {
        setSeconds(prev => {
          if (prev > 1) {
            setTick(t => t + 1)
            return prev - 1
          } else {
            clearInterval(interval)
            return 0
          }
        })
      }, 1000)
    } else {
      setSeconds(null) // hide when not active
    }

    return () => clearInterval(interval)
  }, [showCountDown])

  if (!showCountDown || seconds === null || seconds <= 0) return null

  return (
    <div
      key={tick}
      className={`${styles.wrapper} ${styles.show} ${styles.animate}`}
    >
      {seconds}
    </div>
  )
}
